import { render, staticRenderFns } from "./AxUserAvatarStack.vue?vue&type=template&id=7b38f26b&scoped=true&"
import script from "./AxUserAvatarStack.vue?vue&type=script&lang=ts&"
export * from "./AxUserAvatarStack.vue?vue&type=script&lang=ts&"
import style0 from "./AxUserAvatarStack.vue?vue&type=style&index=0&id=7b38f26b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38f26b",
  null
  
)

export default component.exports